import React from 'react';
import { GiftIcon, HammerIcon, LibraryIcon, RulerIcon } from 'lucide-react';
import { SNAPSHOT, type SnapshotIcon } from '../../data/woodworking';
const ICONS: Record<SnapshotIcon, React.ComponentType<{
  className?: string;
}>> = {
  projects: GiftIcon,
  volumes: LibraryIcon,
  dimensions: RulerIcon,
  rights: HammerIcon
};

/** Evergreen value band under the hero. */
export function ValueStrip() {
  return <section aria-label="What's included" className="border-y border-brass-light/25 bg-bottle" data-id="element-356" data-mp="38ajrh5ns9qqu">
      <ul className="mx-auto grid w-full max-w-6xl grid-cols-2 px-5 sm:px-8 lg:grid-cols-4" data-id="element-357" data-mp="349rkkj2dvxxq">
        {SNAPSHOT.map((item, index) => {
        const Icon = ICONS[item.icon];
        return <li key={item.label} className={`flex flex-col items-center gap-1.5 px-2 py-3.5 text-center sm:flex-row sm:justify-center sm:gap-3 sm:py-5 sm:text-left ${index % 2 === 1 ? 'border-l border-white/15' : ''} ${index >= 2 ? 'border-t border-white/15 lg:border-t-0' : ''} ${index === 2 ? 'lg:border-l' : ''}`} data-id="element-358" data-mp="2ukzru8pi19lr" data-mpi={index}>
              <Icon className="h-5 w-5 shrink-0 text-brass-light" aria-hidden data-id="element-359" data-mp="1acfq4rw1v5tz" />
              <span className="text-balance text-[0.74rem] font-bold uppercase leading-tight tracking-[0.08em] text-white sm:text-[0.82rem]" data-id="element-360" data-mp="1fah8tbpkd34x">{item.label}</span>
            </li>;
      })}
      </ul>
    </section>;
}